import type { Faq, PainPoint } from '../types/content';
export const painPoints: PainPoint[] = [{
  title: 'No saber por dónde empezar',
  text: 'Tenés mucha información, pero ningún paso claro para aplicarla.'
}, {
  title: 'Patrones que se repiten',
  text: 'Volvés a reaccionar igual ante situaciones que te hacen mal.'
}, {
  title: 'Experiencias del pasado',
  text: 'Algunas situaciones anteriores todavía influyen en cómo respondés hoy.'
}, {
  title: 'Autoexigencia constante',
  text: 'Hacés un montón de cosas, pero sentís que nunca es suficiente.'
}, {
  title: 'Culpa al poner límites',
  text: 'Querés decir que no, pero terminás aceptando para no decepcionar.'
}];
export const faqs: Faq[] = [{
  question: '¿Cómo sé por dónde empezar?',
  answer: 'Incluye un plan de siete días con actividades organizadas. También podés consultar directamente el protocolo que necesites.'
}, {
  question: '¿Necesito conocimientos de psicología?',
  answer: 'No. Los materiales usan lenguaje sencillo, ejemplos cotidianos e instrucciones paso a paso.'
}, {
  question: '¿Qué pasa si tengo poco tiempo?',
  answer: 'Tenés rutinas de distintas duraciones y pausas guiadas de cinco minutos para jornadas ocupadas.'
}, {
  question: '¿El kit reemplaza una terapia psicológica?',
  answer: 'No. Es un recurso educativo de autocuidado. No reemplaza la atención de un profesional de salud mental.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después de comprar, recibís por email el acceso inmediato a todo el contenido en formato PDF.'
}];
export const costs = ['Seguís buscando consejos, pero no encontrás un primer paso.', 'Repetís reacciones que después te gustaría haber manejado de otra manera.', 'Te cuesta encontrar palabras para comunicar lo que necesitás.', 'Te exigís demasiado y sentís culpa cuando te priorizás.', 'Querés dedicarte tiempo, pero no tenés una rutina organizada.'];
export const purchases = [['Valentina P.', 'Buenos Aires'], ['Daniela M.', 'Córdoba'], ['Camila S.', 'Rosario'], ['Luciana R.', 'Mendoza'], ['Gabriela T.', 'La Plata'], ['Ivana N.', 'Neuquén'], ['Brenda A.', 'Mar del Plata']];
